import { ApiUrl } from "common/services";
export const QuoteResultsDownloadUri = (uid: string) => `${ApiUrl}/file/download?uid=${uid}`;
